import { ActionTree } from 'vuex';
import { RootState } from '@/store/types';
import { IArticleListState } from '@/store/interfaces';

export const actions: ActionTree<IArticleListState, RootState> = {
  setArticleList({ commit }, articleList) {
    commit('SET_ARTICLE_LIST', articleList);
  },
};
